import { Product } from "./product.models";

export class Variant {
    id: number;
    name: string;
    weight: number;
    variantTypeId: number;
    height: number;
    barCode: string;
    width: number;
    length: number;
    price: number;
    articleId: number;
    article: Product;
    stock: number;
    stocks: any[];
    images: any[];
    min: number;
    max: number;
    sku: string;
    warehouseId: number;
    measurementUnitId: number;
    user: string;
}